import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";
import {IVanillaReaderAppEvent_NAVIGATION_INTENT} from '../VanillaReaderEventBus/IVanillaReaderAppEventTypeMap';

export interface VanillaReaderUiDialogContentsController extends IVanillaReaderUiComponentController, IVanillaReaderUI {}

/**
 * # VanillaReaderUiDialogContentsController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiDialogContents` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiDialogContents
 *
 * */
export class VanillaReaderUiDialogContentsController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.dialogContents.onNavItemClicked(vanillaReaderUiContext._onDialogContentsNavigationItemClicked.bind(vanillaReaderUiContext));
    }

    _onDialogContentsNavigationItemClicked(navigationData: IVanillaReaderAppEvent_NAVIGATION_INTENT): void {
        if (navigationData.locator) {
            this.navigateTo(navigationData.locator.toString());
        }

        this.menuBottom.hide();
        this.dialogContents?.close(false,false);
    };
}
